export enum TRAINING_ENTRY {
    /**
     * @value Select training
     */
    PICKER_TITLE = 'TRAINING_ENTRIES.PICKER_TITLE',
}
